<!--
	The agentation feedback toolbar, for dev builds where the optional package
	installed — mounted once in the root layout. Pages offer it their states to
	step through with `providePageScenarios`.
-->
<script lang="ts">
	import { getAgentation } from './agentation.svelte';
	import { pageScenarios } from './page-scenarios';

	let agentation = $derived(getAgentation());
</script>

{#if agentation?.Toolbar}
	{@const Toolbar = agentation.Toolbar}
	<Toolbar scenarios={pageScenarios} />
{/if}
